// extracted by mini-css-extract-plugin
module.exports = {"payment_info":"noticelist_payment_info__1Fc-D"};